module.exports = __webpack_public_path__ + "videos/timelapse-video-max.4474040.mp4";